import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { writeSessionItem } from 'lib/safeSessionStorage';
import { RootState } from 'lib/store';

interface DynamicValues {
  [key: string]: string;
}

const initialState: DynamicValues = {};

const formSlice = createSlice({
  initialState: initialState,
  name: 'dynamicValues',
  reducers: {
    setDynamicValues: (state, action: PayloadAction<DynamicValues>) => {
      const { value, variableName } = action.payload;
      state[variableName] = value;

      // Super Hack, but whatever
      if (typeof window !== 'undefined') {
        // Chrome and Safari throw on the sessionStorage access when storage
        // is blocked. This reducer runs on every journey answer, so the
        // throw would abort the click before navigation.
        writeSessionItem('dynamicValues', JSON.stringify(state));
      }
    },
    setDynamicValuesAll: (
      state,
      action: PayloadAction<Record<string, any>> // eslint-disable-line @typescript-eslint/no-explicit-any
    ) => {
      return action.payload;
    },
  },
});

const { actions, reducer } = formSlice;

export const { setDynamicValues, setDynamicValuesAll } = actions;

export const selectDynamicValues = (state: RootState) => state.dynamicValues;

export default reducer;
